module.exports = __webpack_public_path__ + "img/310.ed2238f9.png";